export const isRequiredError = <Error>(error?: Error): boolean | string => {
  if (typeof error === 'boolean') {
    return error
  }

  return (
    typeof error === 'string' &&
    (error === 'Обязательное поле' ||
      error.includes('Необходимо заполнить') ||
      error.includes('обязательно для заполнения') ||
      error.includes('Необходимо указать') ||
      error.includes('Заполните данное поле'))
  )
}
